import styled, { css } from 'styled-components';

const ellipsis = css`
  display: -webkit-box;
  -webkit-line-clamp: var(--visible-lines, 1);
  -webkit-box-orient: vertical;
  word-break: break-all;
  overflow: hidden;
`;

export const Ellipsis = styled.span<{ visibleLines?: number }>`
  --visible-lines: ${({ visibleLines = 1 }) => visibleLines};
  ${ellipsis}
`;
